import useResponsive from "@/hooks/useResponsive";
import { FONT_PRIMARY } from "@/theme/typography";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";

const HelpItem = ({ icon: Icon, title, description, href }: { icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>, title: string, description: string, href: string }) => {
  const isMobile = useResponsive("down", "md");
  const theme = useTheme();
  return (
    <Button
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        justifyContent: "start",
        backgroundColor: "transparent",
        padding: { xs: "16px", md: "24px"},
        borderRadius: "12px",
        border: "1px solid #CCCCCC",
        maxWidth: { xs: "100%", md: "488px" },
        boxSizing: "border-box",
        boxShadow: "none",
        ":hover,:focus": {
          boxShadow: "none",
          backgroundColor: "transparent",
          outline: "none"
        },
        ":not(:last-child)": {
          marginRight: { xs: "0px", md: "12px" },
          marginBottom: { xs: "8px", md: "0px" }
        }
      }}
      component={Link}
      variant="contained"
      to={href}
    >
      <Box
        sx={{
          marginBottom: "24px",
          height: isMobile ? "24px" : "32px"
        }}
      >
        <Icon width={isMobile ? "24px" : "32px"} height={isMobile ? "24px" : "32px"}/>
      </Box>
      <Typography
        component="span"
        sx={{
          fontSize: { xs: "1.125rem", md: "1.5rem"},
          fontWeight: "700",
          fontFamily: FONT_PRIMARY,
          marginBottom: { xs: "8px", md: "16px" },
          textAlign: "start",
          color: theme.palette.text.primary
        }}
      >
        {title}
      </Typography>
      <Typography
      component="span"
        sx={{
          fontSize: { xs: "0.875rem", md: "1rem" },
          color: theme.palette.text.secondary,
          textAlign: "start"
        }}
      >
        {description}
      </Typography>
    </Button>
  )
};

export default HelpItem;